import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Link } from "react-router";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { setActivePageTitle } from "../actions/settings";
import BonzaTextField from "../components/BonzaTextField";
import BonzaSelectField from "../components/BonzaSelectField";
import BonzaBooleanField from "../components/BonzaBooleanField";
import BonzaTourTypeSelect from "../components/BonzaTourTypeSelect";
import BonzaDatePickerField from "../components/BonzaDatePickerField";
import LockedPurchaseNotification from "../components/LockedPurchaseNotification";
import config from "../config";

import {
  createTourPurchase,
  updateTourPurchase,
  getTourPurchase,
  getPurchases,
  getEquipmentInventory
} from "../middleware/api/purchases";
import { getCustomerCommission } from "../middleware/api/customers";
import { getProductTourPricing } from "../middleware/api/products";
import {
  getAllotmentsForRange,
  getAllotmentAvailability,
  checkIfDateIsBooked,
} from "../middleware/api/allotments";
import {
  getDiscount,
  getDiscounts,
  generateCode,
} from "../middleware/api/discounts";

import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import EmailIcon from "@material-ui/icons/Email";
import PaymentIcon from "@material-ui/icons/Payment";
import CheckIcon from "@material-ui/icons/Check";
import InfoIcon from "@material-ui/icons/Info";
import PersonIcon from "@material-ui/icons/Person";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import { requestProductPriceUpdate } from "../actions/product";
import spacing from "@material-ui/core/styles/spacing";

const styles = (theme) => ({
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
});

const noMargin = { marginBottom: `0px` };

const initialState = {
  loading: false,

  purchaseId: 0,
  purchaseWasCreated: false,
  purchaseWasUpdated: false,
  confirmationSent: 0,
  detailId: 0,
  invoicesGenerated: 0,

  status: config.statuses[0],
  travelerSectionCollapsed: false,
  saleSectionCollapsed: false,
  tourSectionCollapsed: false,
  emailConfirmationSectionCollapsed: false,
  bookingStatusSectionCollapsed: false,
  paymentSectionCollapsed: false,
  bookingVoucherSectionCollapsed: false,
  travelerLastname: ``,
  travelerFirstname: ``,
  additionalNames: ``,
  phone: ``,
  hotel: ``,
  originCountry: config.countries[0],

  voucher: 0,
  famils: 0,
  voucherLastname: ``,
  voucherFirstname: ``,
  customerId: 0,
  customerNotes: ``,
  bookingRefIDInitial: ``,
  bookingRefID: ``,
  bookingRefIDIsUnique: true,
  bookingRefIDIsRequired: false,
  travelAgency: ``,
  bookingSource: ``,
  bookingSourceIsRequired: false,

  productId: false,
  productIdCheckRangeShow: 0,
  productIdCheckRange: `3:18`,
  twoDayRule: 0,
  tourDate: null,
  bookedDate: 0,
  tourCity: ``,
  optionTourTime: 0,
  overrideTourTime: ``,

  family: 0,

  noOfFamilyGroups: 0,
  familyRate: 0,
  noOfAdditionals: 0,
  additionalRate: 0,
  noOfAddChildren: 0,
  noOfAddAdult: 0,

  noOfAdult: 0,
  adultPrice: 0,
  noOfChildren: 0,
  childPrice: 0,

  noOfBabies: 0,

  totalRiders: 0,
  totalRidersDisabled: false,

  language: config.languages[0],

  noOfEBikes: 0,
  noOfBabySeats: 0,
  noOfTrailAlongs: 0,
  noOfKiddieCarriers: 0,
  noOfSmallKidsBikes: 0,
  noOfLargeKidsBikes: 0,

  eBikePrice: 0,
  babySeatPrice: 0,
  trailAlongPrice: 0,
  kiddieCarrierPrice: 0,
  smallKidsBikePrice: 0,
  largeKidsBikePrice: 0,
  totalEquipmentCost: 0,
  overrideEquipmentCount: 0,

  sendToPartner: 0,
  partnerEmail: ``,
  sendToTourOperator: 0,
  operatorEmail: ``,
  operatorEmail2: ``,
  sendToGuest: 0,
  email: ``,
  guestNote: ``,

  checkIn: 0,
  noShow: 0,
  waiverFormSubmitted: 0,
  waiverFormURL: "",
  confirmedByPartner: 1,

  totalGross: 0,
  commission: 0,
  commissionLevel: 0,
  totalNet: 0,
  discountedAmount: 0,
  internalNotes: ``,
  emailTemplate: ``,
  voucherCode: "",
  voucherValue: 0,
  voucherIDs: "",

  validationErrors: [],
  purchaseIsVoucher: false,
  discounted: false,

  allotmentsData: false,
  disallowDiscountEdit: false,
  disableTotalGross: false,

  totalInventory: false,
};

class TourPurchasePage extends React.Component {
  constructor(props) {
    super(props);

    let stateCopy = initialState;
    (stateCopy.userId = props.user.userId), (this.state = stateCopy);

    this.togglePanel = this.togglePanel.bind(this);
    this.setValue = this.setValue.bind(this);
    this.setValueVoucher = this.setValueVoucher.bind(this);
    this.setValueOfAdultEquipments = this.setValueOfAdultEquipments.bind(this);
    this.setValueOfInfantEquipments = this.setValueOfInfantEquipments.bind(this);
    this.setValueOfKidEquipments = this.setValueOfKidEquipments.bind(this);
    this.setValueTotalGross = this.setValueTotalGross.bind(this);
    this.setValueTourType = this.setValueTourType.bind(this);
    this.resetPaxSelection = this.resetPaxSelection.bind(this);
    this.totalRider = this.totalRider.bind(this);
    this.updateSinglePrice = this.updateSinglePrice.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onFormSubmitAndTakePayment = this.onFormSubmitAndTakePayment.bind(this);
    this.checkReferenceIdUniqueness = this.checkReferenceIdUniqueness.bind(this);
    this.resetEquipmentOverride = this.resetEquipmentOverride.bind(this);
    
    if (props.params.id) {
      props.dispatch(setActivePageTitle(`Edit tour purchase`));
    } else {
      props.dispatch(setActivePageTitle(`Add tour purchase`));
    }
  }

  componentWillMount() {
    if (this.props.params.id) {
      this.setState({ loading: true });

      getTourPurchase(this.props.params.id)
        .then((editedPurchase) => {
          // No null values are allowed
          for (let key in editedPurchase) {
            if (editedPurchase[key] === null) editedPurchase[key] = ``;
          }

          // Customer notes
          if (!editedPurchase.customerNotes) {
            editedPurchase.customerNotes = ``;
          } else {
            editedPurchase.customerNotes = editedPurchase.customerNotes.trim();
          }

          // Overridden tour time
          if (editedPurchase.overrideTourTime) {
            editedPurchase.optionTourTime = 1;
          }

          // Normalizing integer values
          [
            `noOfFamilyGroups`,
            `noOfAdditionals`,
            `noOfAddChildren`,
            `noOfAddAdult`,
            `noOfAdult`,
            `noOfChildren`,
            `noOfBabies`,
            `totalRiders`,
            `noOfEBikes`,
            `noOfBabySeats`,
            `noOfTrailAlongs`,
            `noOfKiddieCarriers`,
            `noOfSmallKidsBikes`,
            `noOfLargeKidsBikes`,
          ].map((item) => {
            if (editedPurchase[item] === ``) {
              editedPurchase[item] = 0;
            } else {
              editedPurchase[item] = parseInt(editedPurchase[item]);
            }
          });

          // Normalizing float values
          [
            `familyRate`,
            `additionalRate`,
            `adultPrice`,
            `childPrice`,
            `totalGross`,
            `commission`,
            `commissionLevel`,
            `totalNet`,
            `discountedAmount`,
            `eBikePrice`,
            `babySeatPrice`,
            `trailAlongPrice`,
            `kiddieCarrierPrice`,
            `smallKidsBikePrice`,
            `largeKidsBikePrice`,
            `totalEquipmentCost`,
          ].map((item) => {
            if (editedPurchase[item] === ``) {
              editedPurchase[item] = 0;
            } else {
              editedPurchase[item] = parseFloat(editedPurchase[item]);
            }
          });

          if (editedPurchase.operatorEmail)
            editedPurchase.operatorEmail2 = editedPurchase.operatorEmail;
          editedPurchase.tourDate = new Date(
            editedPurchase.tourDate.indexOf("T") === -1
              ? editedPurchase.tourDate
              : editedPurchase.tourDate.split(`T`)[0] + "T00:00:00",
          );
          editedPurchase.totalRidersDisabled = true;

          editedPurchase.loading = false;

          if (editedPurchase.bookingRefID) {
            editedPurchase.bookingRefIDInitial = editedPurchase.bookingRefID;
          }

          editedPurchase.totalRiders = this.getTotalRiders(editedPurchase).total;

          this.setState(editedPurchase, () => {
            this.setValueTourType(
              `tourType`,
              this.state.productId,
              false,
              false,
            );


            // Get Inventory Consumption
            let td = moment(editedPurchase.tourDate).format(`YYYY-MM-DD`);
            console.log("Tour date: " + td);
            this.updateEquipmentInventory(td);

            // console.log("DISCOUNTED AMOUNT: " + editedPurchase.discountedAmount);
            // console.log("VOUCHER CODE : " + editedPurchase.voucherCode);
            // console.log("WILLMOUNT: " + this.state.noOfEBikes + " : " + this.state.eBikePrice);
            // console.log("WILLMOUNT: " + this.state.noOfBabySeats + " : " + this.state.babySeatPrice);
            // console.log("WILLMOUNT: " + this.state.noOfTrailAlongs + " : " + this.state.trailAlongPrice);
            // console.log("WILLMOUNT: " + this.state.noOfKiddieCarriers + " : " + this.state.kiddieCarrierPrice);
            // console.log("WILLMOUNT: " + this.state.noOfSmallKidsBikes + " : " + this.state.smallKidsBikePrice);
            // console.log("WILLMOUNT: " + this.state.noOfLargeKidsBikes + " : " + this.state.largeKidsBikePrice);

            if (editedPurchase.product.typeCode !== "VOUCHERS") {
              if (editedPurchase.voucherCode) {
                this.state.voucherValue = editedPurchase.discountedAmount;

                this.state.disallowDiscountEdit = true;
                this.state.disableTotalGross = true;
                // console.log("disallowDiscountEdit : " + this.state.disallowDiscountEdit);
              }
            } else {
              const discountsPromised = this.state.voucherIDs
                .split(",")
                .map((discountID) => {
                  return getDiscount(discountID);
                });

              Promise.all(discountsPromised)
                .then((response) => {
                  const voucherCodes = response.reduce((acc, cur) => {
                    return acc
                      ? `${acc},${cur.discountCode}`
                      : cur.discountCode;
                  }, "");

                  if (voucherCodes !== undefined) {
                    this.setState((state) => {
                      return {
                        ...state,
                        voucherCode: voucherCodes,
                      };
                    });
                  }
                })
                .catch((err) => {
                  this.setState((state) => {
                    return {
                      ...state,
                      validationErrors: [
                        `Failed to load discount codes: ${JSON.stringify(err)}`,
                      ],
                    };
                  });
                });
            }
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            validationErrors: [
              `Unable to get the purchase with identifier ${this.props.params.id}`,
            ],
          });
        });
    }
  }
  isPurchasedProductVoucher() {
    if (!this.state.product || this.state.product === undefined) {
      return false;
    }
    return this.state.product.typeCode === "VOUCHERS";
  }
  getTotalRiders(stateCopy) {
    let total = 0,
    sum = 0;
    console.log("INSIDE getTotalRiders: stateCopy.family = " + stateCopy.family);

    if (stateCopy.family === 0) {
      total = stateCopy.noOfAdult + stateCopy.noOfChildren;
      sum =
        stateCopy.noOfAdult * stateCopy.adultPrice +
        stateCopy.noOfChildren * stateCopy.childPrice;
    } else {
      console.log("INSIDE getTotalRiders ELSE");
      total =
        stateCopy.noOfFamilyGroups * 4 +
        stateCopy.noOfAddAdult +
        stateCopy.noOfAddChildren;

      console.log(" stateCopy.noOfFamilyGroups: " + stateCopy.noOfFamilyGroups);
      console.log(" stateCopy.noOfAddAdult: " + stateCopy.noOfAddAdult);
      console.log(" stateCopy.noOfAddChildren: " + stateCopy.noOfAddChildren);
      sum =
        stateCopy.noOfFamilyGroups * stateCopy.familyRate +
        stateCopy.noOfAddAdult * stateCopy.additionalRate +
        stateCopy.noOfAddChildren * stateCopy.additionalRate;
    }

    return { total, sum };
  }
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      validationErrors: [],
    });
  };

  checkReferenceIdUniqueness(value) {
    if (!this.state.bookingRefIDIsUnique) {
      this.setState({ bookingRefIDIsUnique: true });
    }

    if (value) {
      getPurchases({ bookingReferenceId: value, purchaseType: `tour` }).then(
        (result) => {
          if (result.total > 0) {
            this.setState({ bookingRefIDIsUnique: false });
          }
        },
      );
    }
  }

  validate() {
    return new Promise((resolve, reject) => {
      let errors = [];

      let nexttwo = new Date();
      nexttwo.setDate(nexttwo.getDate() + 2);
      nexttwo = moment(nexttwo).format(`YYYYMMDD`);
      let strTourDate = moment(this.state.tourDate).format(`YYYYMMDD`);
      let todayTourDate = moment(new Date()).format(`YYYYMMDD`);

      // 2 Day Rule
      if (
        this.state.bookedDate === 0 &&
        this.state.totalRiders == 1 &&
        this.state.twoDayRule &&
        nexttwo > strTourDate &&
        strTourDate >= todayTourDate
      ) {
        errors.push(`Single Rider 2-Day Rule, unable to process purchase`);
      }

      if (this.state.optionTourTime && !this.state.overrideTourTime) {
        errors.push(`Departure time needs to be filled`);
      }

      if (
        (this.state.sendToPartner ||
          this.state.sendToTourOperator ||
          this.state.sendToGuest) &&
        this.state.emailTemplate === ``
      ) {
        errors.push(
          `Email template has not been assigned to the product, please assign an email template first`,
        );
      }

      if (this.state.sendToPartner) {
        if (this.state.partnerEmail === ``) {
          errors.push(`Booking partner email needs to be filled`);
        }
      }

      if (this.state.sendToTourOperator) {
        if (this.state.operatorEmail === ``) {
          errors.push(`Please enter operator email`);
        } else if (this.state.operatorEmail !== this.state.operatorEmail2) {
          errors.push(
            `Operator emails do not match, please retype operator email`,
          );
        }
      }

      if (this.state.sendToGuest) {
        if (this.state.email === ``) {
          errors.push(`Please enter traveller email`);
        }
      }

      // Ref ID Check
      if (this.state.bookingRefIDIsRequired && this.state.bookingRefID === ``) {
        errors.push(`Booking reference needs to be filled`);
      }

      if (this.state.bookingSourceIsRequired) {
        errors.push(`Booking source needs to be filled`);
      }

      if (!this.state.travelerLastname) {
        errors.push(`Traveller last name needs to be filled`);
      }

      if (this.state.customerId === 0) {
        errors.push(`Booking partner needs to be selected`);
      }

      if (!this.state.tourDate) {
        errors.push(`Tour date needs to be set`);
      }

      if (this.state.totalRiders === 0) {
        errors.push(`Please add at least one rider`);
      }

      this.props.products.map((product) => {
        if (parseInt(product.productID) === parseInt(this.state.productId)) {
          if (
            product.minGuestNo &&
            this.state.totalRiders < product.minGuestNo &&
            this.state.twoDayRule === 0
          ) {
            errors.push(
              `Minimum ${product.minGuestNo} guests required - Override to allow the booking to go ahead`,
            );
          }
        }
      });

      if (errors.length === 0) {
        // Allotment Check
        if (this.state.purchaseIsVoucher) {
          resolve();
        } else {
          getAllotmentAvailability(
            this.state.productId,
            moment(this.state.tourDate).format(`YYYY-MM-DD`),
          ).then((result) => {
            let available = result.available;
            if (available !== 0) {
              if (
                available < this.state.totalRiders &&
                this.state.twoDayRule === 0
              ) {
                errors.push(
                  `Not enough allotment on the selected day, please adjust the allotment`,
                );
              }
            } else if (
              this.state.voucher === 0 &&
              this.state.twoDayRule === 0
            ) {
              errors.push(
                `No allotment on the day, please adjust the allotment`,
              );
            }

            if (errors.length === 0) {
              resolve();
            } else {
              reject(errors);
            }
          });
        }
      } else {
        reject(errors);
      }
    });
  }

  onFormSubmitAndTakePayment() {
    this.onFormSubmit(true);
  }

  onFormSubmit(payAfterwards = false) {
    console.log("onFormSubmit : ");

    this.setState({ loading: true });
    this.setState({ discountedAmount: this.state.voucherValue });
    this.state.noOfAdditionals = this.state.noOfAddAdult + this.state.noOfAddChildren;
    // console.log("after onFormSubmit");
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfEBikes + " : " + this.state.eBikePrice);
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfBabySeats + " : " + this.state.babySeatPrice);
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfTrailAlongs + " : " + this.state.trailAlongPrice);
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfKiddieCarriers + " : " + this.state.kiddieCarrierPrice);
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfSmallKidsBikes + " : " + this.state.smallKidsBikePrice);
    // console.log("INSIDE ONFORMSUBMIT: " + this.state.noOfLargeKidsBikes + " : " + this.state.largeKidsBikePrice);
    // console.log("INSIDE ONFORMSUBMIT: this.state.noOfAddAdult  : " + this.state.noOfAddAdult);
    // console.log("INSIDE ONFORMSUBMIT: this.state.noOfAddChildren  : " + this.state.noOfAddChildren);
    // console.log("INSIDE ONFORMSUBMIT: this.state.noOfAdditionals :"  + this.state.noOfAdditionals);

    this.validate()
      .then(() => {
        let stateCopy = JSON.parse(JSON.stringify(this.state));

        let data = {};
        [
          `additionalRate`,
          `additionalNames`,
          `adultPrice`,
          `bookingRefID`,
          `bookingSource`,
          `checkIn`,
          `childPrice`,
          `commission`,
          `commissionLevel`,
          `confirmedByPartner`,
          `originCountry`,
          `customerId`,
          `customerNotes`,
          `email`,
          `emailTemplate`,
          `famils`,
          `family`,
          `familyRate`,
          `guestNote`,
          `hotel`,
          `internalNotes`,
          `language`,
          `travelerFirstname`,
          `travelerLastname`,
          `noOfAddChildren`,
          `noOfAddAdult`,
          `noOfAdditionals`,
          `noOfAdult`,
          `noOfBabies`,
          `noOfChildren`,
          `noOfFamilyGroups`,
          `noShow`,
          `noOfEBikes`,
          `noOfBabySeats`,
          `noOfTrailAlongs`,
          `noOfKiddieCarriers`,
          `noOfLargeKidsBikes`,
          `noOfSmallKidsBikes`,
          `eBikePrice`,
          `babySeatPrice`,
          `trailAlongPrice`,
          `kiddieCarrierPrice`,
          `smallKidsBikePrice`,
          `largeKidsBikePrice`,
          `totalEquipmentCost`,
          'waiverFormSubmitted',
          'waiverFormURL',
          `operatorEmail`,
          `operatorEmail2`,
          `optionTourTime`,
          `overrideTourTime`,
          `partnerEmail`,
          `phone`,
          `productId`,
          `purchaseId`,
          `sendToGuest`,
          `sendToTourOperator`,
          `sendToPartner`,
          `status`,
          `totalGross`,
          `totalNet`,
          `discountedAmount`,
          `totalRiders`,
          `tourCity`,
          `travelAgency`,
          `twoDayRule`,
          `userId`,
          `voucher`,
          `voucherFirstname`,
          `voucherLastname`,
          `voucherCode`,
          `voucherIDs`,
          `discounted`,
        ].map((item) => {
          if (stateCopy[item] !== null) {
            data[item] = stateCopy[item].toString();
          }
        });

        console.log("INSIDE ONFORMSUBMIT: AFTER statecopy");

        data.tourDate = moment(stateCopy.tourDate).format(`YYYY-MM-DD`);
        data.voucherExpireDate = moment(stateCopy.voucherExpireDate).format(
          `YYYY-MM-DD`,
        );

        data.city = stateCopy.tourCity;
        data.family = stateCopy.family.toString();

        console.log("INSIDE ONFORMSUBMIT: Before create");

        if (stateCopy.purchaseId > 0) {
          updateTourPurchase(stateCopy.detailId, data)
            .then(() => {
              this.setState({ purchaseWasUpdated: true });

              console.log("Updating Equipment Purchase");

              this.updateEquipmentInventory(data.tourDate);
            })
            .catch((err) => {
              this.setState({
                loading: false,
                validationErrors: [`Error occured while updating purchase`],
              });
            });
        } else {
          createTourPurchase(data)
            .then((identifiers) => {
              if (payAfterwards === true) {
                this.props.router.push(
                  `/purchases/${identifiers.purchaseId}/payment`,
                );
              } else {
                identifiers.purchaseWasCreated = true;
                this.setState(identifiers);
              }

              console.log("Updating Equipment Inventory");
              this.updateEquipmentInventory(data.tourDate);
            })
            .catch(() => {
              this.setState({
                loading: false,
                validationErrors: [`Error occured while creating purchase`],
              });
            });
        }
      })
      .catch((validationErrors) => {
        console.log(validationErrors);
        this.setState({
          loading: false,
          validationErrors: Array.isArray(validationErrors)
            ? validationErrors
            : [validationErrors],
        });
      });
  }

  togglePanel(name) {
    if (name in this.state === false) {
      throw new Error(`Invalid panel name ${name}`);
    }

    this.setState({ [name]: !this.state[name] });
  }

  updateAmounts(newState, voucherValue) {
    console.log("INSIDE updateAmounts, Gross: " + newState.totalGross);

    newState.voucherValue = voucherValue;
    console.log("voucherValue : " + voucherValue);
    console.log("totalEquipmentCost : " + newState.totalEquipmentCost);

    console.log("commissionLevel: " + this.state.commissionLevel);
    let commission = ((newState.totalGross + newState.totalEquipmentCost - voucherValue) * this.state.commissionLevel) / 100;
    commission = commission.toFixed(2);
    console.log("commission: " + commission);
    let sum = newState.totalGross + newState.totalEquipmentCost - commission;
    newState.commission = commission;
    newState.totalNet = parseFloat((sum - voucherValue).toFixed(2));
    console.log("totalNet: " + newState.totalNet);

    if (this.state.status.toLowerCase() === `cancelled`) {
      newState.commission = 0;
      newState.totalNet = 0;
      newState.totalGross = 0;
      newState.discountedAmount = 0;
      newState.voucherValue = 0;
      newState.voucherCode = "";
      newState.discounted = false;
      newState.totalEquipmentCost = 0;
    }

    // console.log("EXITING updateAmounts");
    return newState;
  }

  totalRider(optionalTotalGross = false) {
    console.log("ENTERING totalRider (this.state.totalRiders) : " + this.state.totalRiders);

    let { total, sum } = this.getTotalRiders(this.state);
    let newState = {};
    let discountAmount = 0;

    newState.totalEquipmentCost = this.setTotalEquipmentCost();

    newState.totalEquipmentCost = this.state.totalEquipmentCost;
    newState.totalRiders = total;
    newState.totalGross = optionalTotalGross === false ? parseFloat(sum.toFixed(2)) : optionalTotalGross;

    if (this.state.voucherCode) {
      this.calculateDiscount(newState.totalGross + newState.totalEquipmentCost).then(discountAmount => {
          // console.log("totalRider::calculateDiscount returned : " + discountAmount);
          // console.log("totalRider::this.state.discountedAmount : " + this.state.discountedAmount);

          if (this.state.disallowDiscountEdit && this.state.discountedAmount != 0) {
            console.log("Updating Discount");
            discountAmount = Math.min(discountAmount, this.state.discountedAmount);
          }

          newState = this.updateAmounts(newState, discountAmount);
          this.setState(newState);
          // console.log("totalRider::calculateDiscount::DISCOUNTED : " + this.state.discounted);
        })
        .catch((err) => {
          console.log(err);
          this.setState((state) => {
            return {
              ...state,
              voucherCode: "",
              validationErrors: [`${err}`],
            };
          });
        });
    } else {
      newState = this.updateAmounts(newState, discountAmount);
      this.setState(newState);
      // console.log("totalRider::DISCOUNTED : " + this.state.discounted);
    }

    // console.log("EXITING totalRider ");
  }

  updateSinglePrice() {
    let newState = {};

    let noOfRiders = 0;
    let totalPrice = 0;
    if (this.state.family === 0) {
      noOfRiders = noOfRiders + this.state.noOfAdult;
      totalPrice = totalPrice + this.state.noOfAdult * this.state.adultPrice;
      noOfRiders = noOfRiders + this.state.noOfChildren;
      totalPrice = totalPrice + this.state.noOfChildren * this.state.childPrice;
    } else {
      this.state.noOfAdditionals = this.state.noOfAddAdult + this.state.noOfAddChildren;
      noOfRiders = noOfRiders + this.state.noOfFamilyGroups;
      totalPrice = totalPrice + this.state.noOfFamilyGroups * this.state.familyRate;
      noOfRiders = noOfRiders + this.state.noOfAdditionals;
      totalPrice = totalPrice + this.state.noOfAdditionals * this.state.additionalRate;
    }

    let diff = this.state.totalGross - totalPrice;
    let singleDiff = diff / noOfRiders;

    if (this.state.family === 0) {
      if (this.state.noOfAdult !== 0) {
        let adultPrice = this.state.adultPrice + singleDiff;
        newState.adultPrice = parseFloat(adultPrice.toFixed(2));
      }

      if (this.state.noOfChildren !== 0) {
        let childPrice = this.state.childPrice + singleDiff;
        newState.childPrice = parseFloat(childPrice.toFixed(2));
      }
    } else {
      if (this.state.noOfFamilyGroups !== 0) {
        let familyRate = this.state.familyRate + singleDiff;
        newState.familyRate = parseFloat(familyRate.toFixed(2));
      }

      if (this.state.noOfAdditionals !== 0) {
        let additionalRate = this.state.additionalRate + singleDiff;
        newState.additionalRate = parseFloat(additionalRate.toFixed(2));
      }
    }

    return newState;
  }

  generatePriceOriginMessage(newPrices) {
    let message = ``;
    if (newPrices.overriddenByBookingPartner) {
      message = `Prices are taken from Booking partner override values`;
    } else if (newPrices.appliedSeasonName) {
      message = `Prices are taken from Product price season "${newPrices.appliedSeasonName}"`;
    } else {
      message = `Prices are taken from regular product settings`;
    }

    return message;
  }

  setValueTourType(
    name,
    value,
    recalculate = true,
    setPricesAndTourTime = true,
  ) {
    this.setState({ loading: true });

    let requestedDate = moment().format(`YYYY-MM-DD`);
    if (this.state.tourDate)
      requestedDate = moment(this.state.tourDate).format(`YYYY-MM-DD`);

    getProductTourPricing(this.state.customerId, value, requestedDate)
      .then((result) => {
        // console.log("RESULT : " + result.eBikePrice);
        // console.log("RESULT : " + result.babySeatPrice);
        // console.log("RESULT : " + result.trailAlongPrice);
        // console.log("RESULT : " + result.smallKidsBikePrice);
        // console.log("RESULT : " + result.largeKidsBikePrice);

        let newState = { productId: value };
        if (result) {
          newState.confirmedByPartner = parseInt(result.confirmedByPartner);
          if (setPricesAndTourTime) {
            newState.additionalRate = result.additionalRate
              ? parseFloat(result.additionalRate)
              : 0;
            newState.adultPrice = result.adultPrice
              ? parseFloat(result.adultPrice)
              : 0;
            newState.childPrice = result.childPrice
              ? parseFloat(result.childPrice)
              : 0;
            newState.familyRate = result.familyRate
              ? parseFloat(result.familyRate)
              : 0;
            newState.priceOrigin = this.generatePriceOriginMessage(result);

            // Equipment Prices Begins
            newState.eBikePrice = result.eBikePrice
              ? parseFloat(result.eBikePrice)
              : 0;
            newState.babySeatPrice = result.babySeatPrice
              ? parseFloat(result.babySeatPrice)
              : 0;
            newState.trailAlongPrice = result.trailAlongPrice
              ? parseFloat(result.trailAlongPrice)
              : 0;
            newState.kiddieCarrierPrice = result.kiddieCarrierPrice
              ? parseFloat(result.kiddieCarrierPrice)
              : 0;
            newState.smallKidsBikePrice = result.smallKidsBikePrice
              ? parseFloat(result.smallKidsBikePrice)
              : 0;
            newState.largeKidsBikePrice = result.largeKidsBikePrice
              ? parseFloat(result.largeKidsBikePrice)
              : 0;
            // Equipment Prices Ends
          }

          newState.tourCity = result.tourCity;
          newState.emailTemplate = result.emailTemplate;
        }

        getAllotmentsForRange(value, this.state.productIdCheckRange)
          .then((result) => {
            newState.allotmentsData = result;
            newState.loading = false;

            // Whenever new product is seleted, the departure time needd to be set to the default value
            if (setPricesAndTourTime) {
              newState.optionTourTime = 0;
              newState.overrideTourTime = ``;
            }

            this.setState(newState, () => {
              if (recalculate) this.totalRider();
            });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
    if (name === "productId") {
      const found = !!this.props.products
        ? this.props.products.find((product) => {
            return product.productID === Number(value);
          })
        : null;

      if (!found) {
        return;
      }
      //const voucherCode = generateCode();
      const purchaseIsVoucher = found.typeCode === "VOUCHERS";
      this.setState((state) => {
        return {
          ...state,
          purchaseIsVoucher: purchaseIsVoucher,
          tourDate:
            found.typeCode === "VOUCHERS"
              ? new Date(2050, 1, 1)
              : this.state.tourDate,
          //voucherCode: purchaseIsVoucher ? voucherCode[0] : ''
        };
      });
    }
  }

  setValueTotalGross(name, value) {
    if(this.state.disableTotalGross) {
      this.setState((state) => {
        return{
          ...state,
          validationErrors: [
            "You cannot adjust gross sale when discount has been added. Please manually calculate the price per guest and equipment and update above.",
          ],
        };
      });
    } else {
      this.setState({ totalGross: parseFloat(value) }, () => {
        let updatedStateValues = this.updateSinglePrice();
        this.setState(updatedStateValues, () => {
          this.totalRider(parseFloat(value));
        });
      });
    }
  }

  setTotalEquipmentCost() {
    this.state.totalEquipmentCost =
      this.state.noOfEBikes * this.state.eBikePrice +
      this.state.noOfBabySeats * this.state.babySeatPrice +
      this.state.noOfTrailAlongs * this.state.trailAlongPrice +
      this.state.noOfKiddieCarriers * this.state.kiddieCarrierPrice +
      this.state.noOfSmallKidsBikes * this.state.smallKidsBikePrice +
      this.state.noOfLargeKidsBikes * this.state.largeKidsBikePrice;

    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfEBikes + " : " + this.state.eBikePrice);
    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfBabySeats + " : " + this.state.babySeatPrice);
    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfTrailAlongs + " : " + this.state.trailAlongPrice);
    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfKiddieCarriers + " : " + this.state.kiddieCarrierPrice);
    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfSmallKidsBikes + " : " + this.state.smallKidsBikePrice);
    console.log("INSIDE setTotalEquipmentCost: " + this.state.noOfLargeKidsBikes + " : " + this.state.largeKidsBikePrice);
    console.log("totalEquipmentCost: " + this.state.totalEquipmentCost);

    return this.state.totalEquipmentCost;
  }

  checkEquipmentInventory (fieldName, value, equipmentName, inventoryItemName, errMsg, 
            numberOfPax, newEquipmentCount) {

    console.log ("overrideEquipmentCount : " + this.state.overrideEquipmentCount);

    let totalBooked =  this.state.totalInventory[`${inventoryItemName}`] ? 
                          parseInt(this.state.totalInventory[`${inventoryItemName}`].totalBooked) : 0;
    let totalInventory =  this.state.totalInventory ? (this.state.totalInventory[`${inventoryItemName}`].totalInventory ? 
                            parseInt(this.state.totalInventory[`${inventoryItemName}`].totalInventory) : 0) : 0;
    let overBooking = totalBooked  + value - totalInventory;
    let newErrMsg = errMsg;
    let showErrorMessage = false;

    if (!this.state.overrideEquipmentCount && (overBooking > 0)) {
      showErrorMessage = true;

      if (newEquipmentCount > numberOfPax) {
        newErrMsg = "ERROR: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour. Also " + errMsg;
      } else {
        newErrMsg = "ERROR: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour."
      }
    } else {
      if (newEquipmentCount <= numberOfPax) {
        this.setState({ [fieldName]: value }, this.totalRider);
        if (overBooking > 0) {
          showErrorMessage = true;
          newErrMsg = "WARNING: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour."
        }
      } else {
        showErrorMessage = true;
        newErrMsg = "ERROR: " + errMsg;
      }
    }

    return [showErrorMessage, newErrMsg];
  }

  setValueOfAdultEquipments(name, value) {
    let showErrorMessage = false;
    let numberOfAddAdults = this.state.noOfAddAdult;
    let numberOfAdults = this.state.noOfAdult;
    let numberOfEBikes = this.state.noOfEBikes;
    let numberOfFamilyGroups = this.state.noOfFamilyGroups;
    let errMsg = "e-Bikes are only available for adults at this time. The number of e-bikes you have added to the booking exceed the number of adults in the booking.";

    if (name === "noOfEBikes") {
      numberOfEBikes = value;
    } else if (name === "noOfFamilyGroups") {
      numberOfFamilyGroups = value;
      this.setValueOfKidEquipments(name, value);
    } else if (name === "noOfAddAdult") {
      numberOfAddAdults = value;
    } else if (name === "noOfAdult") {
      numberOfAdults = value;
    }

    if (numberOfFamilyGroups > 0) {
      numberOfAdults = numberOfFamilyGroups * 2 + numberOfAddAdults;
    }

    console.log("numberOfAdults : " + numberOfAdults + ", numberOfEBikes: " + numberOfEBikes);

    if (name === "noOfEBikes") {
      [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "e-bikes", "eBikeInventory", errMsg, 
            numberOfAdults, numberOfEBikes);
    } else {
      if (name === "noOfAddAdult") {
        if (numberOfFamilyGroups > 0) {
          this.setState({ [name]: value }, this.totalRider);
        } else {
          this.setState((state) => {
            return {
              ...state,
              validationErrors: [
                "Additional adult can be added only after adding a Family Group.",
              ],
            };
          });
        }
      } else {
        this.setState({ [name]: value }, this.totalRider);
      }

      if (numberOfEBikes > numberOfAdults) {
        this.setValue("noOfEBikes", numberOfAdults);
        showErrorMessage = true;
        errMsg = "ERROR: " + errMsg;
      }
    }

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  setValueOfInfantEquipments(name, value) {
    let showErrorMessage = false;
    let numberOfBabies = this.state.noOfBabies;
    let numberOfBabySeats = this.state.noOfBabySeats;
    let errMsg = "Baby Seats are only available for Infants at this time. The number of baby seats you add to the booking can't be more than the number of infants in the booking.";

    if (name === "noOfBabies") {
      numberOfBabies = value;
      this.setState({ [name]: value }, this.totalRider);

      if (numberOfBabySeats > numberOfBabies) {
        this.setValue("noOfBabySeats", numberOfBabies);
        showErrorMessage = true;
        errMsg = "ERROR: " + errMsg;
      }
    } else if (name === "noOfBabySeats") {
      numberOfBabySeats = value;

      [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "baby seats", "babySeatInventory", errMsg, 
              numberOfBabies, numberOfBabySeats);
    }

    console.log("numberOfBabies : " + numberOfBabies + ", numberOfBabySeats: " + numberOfBabySeats);

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  setValueOfKidEquipments(name, value) {
    let showErrorMessage = false;

    let numberOfFamilyGroups = this.state.noOfFamilyGroups;
    let numberOfAddChildren = this.state.noOfAddChildren;
    let numberOfChildren = this.state.noOfChildren;
    let numberOfTrailAlongs = this.state.noOfTrailAlongs;
    let numberOfKiddieCarriers = this.state.noOfKiddieCarriers;
    let numberOfSmallKidsBikes = this.state.noOfSmallKidsBikes;
    let numberOfLargeKidsBikes = this.state.noOfLargeKidsBikes;
    let totalKidsEquipments = 0;
    let errMsg = "Kids equipments are only available for kids at this time. The number of kid equipments you add to the booking can't be more than the number of kids (excluding infants) in the booking.";

    if (name === "noOfTrailAlongs") {
      numberOfTrailAlongs = value;
    } else if (name === "noOfKiddieCarriers") {
      numberOfKiddieCarriers = value;
    } else if (name === "noOfSmallKidsBikes") {
      numberOfSmallKidsBikes = value;
    } else if (name === "noOfLargeKidsBikes") {
      numberOfLargeKidsBikes = value;
    } else if (name === "noOfAddChildren") {
      numberOfAddChildren = value;
    } else if (name === "noOfChildren") {
      numberOfChildren = value;
    } else if (name === "noOfFamilyGroups") {
      numberOfFamilyGroups = value;
    }

    if (numberOfFamilyGroups > 0) {
      numberOfChildren = numberOfFamilyGroups * 2 + numberOfAddChildren;
    }

    totalKidsEquipments = numberOfTrailAlongs + numberOfKiddieCarriers + numberOfSmallKidsBikes + numberOfLargeKidsBikes;
    console.log("numberOfChildren : " + numberOfChildren + ", totalKidsEquipments : " + totalKidsEquipments); 

    switch (name) {
      case "noOfTrailAlongs":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "trail alongs", "trailAlongInventory", errMsg, 
                  numberOfChildren, totalKidsEquipments);
        break;
      case "noOfKiddieCarriers":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "kiddie carriers", "kiddieCarrierInventory", errMsg, 
                  numberOfChildren, totalKidsEquipments);
        break;
      case "noOfSmallKidsBikes":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "small kids bikes", "smallKidsBikeInventory", errMsg, 
                  numberOfChildren, totalKidsEquipments);
        break;
      case "noOfLargeKidsBikes":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "large kids bikes", "largeKidsBikeInventory", errMsg, 
                  numberOfChildren, totalKidsEquipments);
        break;
      case "noOfAddChildren":
        if (numberOfFamilyGroups > 0) {
          this.setState({ [name]: value }, this.totalRider);
          if (totalKidsEquipments > numberOfChildren) {
            if (numberOfTrailAlongs > 0) {
              this.setValue("noOfTrailAlongs", numberOfTrailAlongs - 1);
            } else if (numberOfKiddieCarriers > 0) {
              this.setValue("noOfKiddieCarriers", numberOfKiddieCarriers - 1);
            } else if (numberOfSmallKidsBikes > 0) {
              this.setValue("noOfSmallKidsBikes", numberOfSmallKidsBikes - 1);
            } else if (numberOfLargeKidsBikes > 0) {
              this.setValue("noOfLargeKidsBikes", numberOfLargeKidsBikes - 1);
            }
            showErrorMessage = true;
            errMsg = "ERROR: " + errMsg;
          }
        } else {
          this.setState((state) => {
            return {
              ...state,
              validationErrors: [
                "Additional child can be added only after adding a Family Group.",
              ],
            };
          });
        }
        break;
      case "noOfChildren":
        this.setState({ [name]: value }, this.totalRider);

        if (totalKidsEquipments > numberOfChildren) {
          if (numberOfTrailAlongs > 0) {
            this.setValue("noOfTrailAlongs", numberOfTrailAlongs - 1);
          } else if (numberOfKiddieCarriers > 0) {
            this.setValue("noOfKiddieCarriers", numberOfKiddieCarriers - 1);
          } else if (numberOfSmallKidsBikes > 0) {
            this.setValue("noOfSmallKidsBikes", numberOfSmallKidsBikes - 1);
          } else if (numberOfLargeKidsBikes > 0) {
            this.setValue("noOfLargeKidsBikes", numberOfLargeKidsBikes - 1);
          }
          showErrorMessage = true;
          errMsg = "ERROR: " + errMsg;
        }

        break;
      case "noOfFamilyGroups":
        if (totalKidsEquipments > numberOfChildren) {
          this.setValue("noOfTrailAlongs", 0);
          this.setValue("noOfKiddieCarriers", 0);
          this.setValue("noOfSmallKidsBikes", 0);
          this.setValue("noOfLargeKidsBikes", 0);
          showErrorMessage = true;
          errMsg = "ERROR: " + errMsg;
        }
        if (numberOfFamilyGroups === 0) {
          this.setValue("noOfAddAdditionals", 0);
          this.setValue("noOfAddAdult", 0);
          this.setValue("noOfEBikes", 0);
          this.setValue("noOfBabies", 0);
          this.setValue("noOfBabySeats", 0);
          this.setValue("noOfAddChildren", 0);
          this.setValue("noOfTrailAlongs", 0);
          this.setValue("noOfKiddieCarriers", 0);
          this.setValue("noOfSmallKidsBikes", 0);
          this.setValue("noOfLargeKidsBikes", 0);
        }

      default:
        break;
    }

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  setValueVoucher(name, value) {
    let newState = { voucher: value };
    if (value === 1) {
      newState.tourDate = new Date(2050, 1, 1);
    }

    this.setState(newState);
  }

  resetPaxSelection(name, value) {
    if (value === 1) {
      this.setValue("noOfAdult", 0);
      this.setValue("noOfChildren", 0);
    } else {
      this.setValue("noOfFamilyGroups", 0);
      this.setValue("noOfAddAdult", 0);
      this.setValue("noOfAddChildren", 0);
      this.setValue("noOfAddAdditionals", 0);
    }
    this.setValue("noOfBabies", 0);
    this.setValue("noOfEBikes", 0);
    this.setValue("noOfBabySeats", 0);
    this.setValue("noOfTrailAlongs", 0);
    this.setValue("noOfKiddieCarriers", 0);
    this.setValue("noOfSmallKidsBikes", 0);
    this.setValue("noOfLargeKidsBikes", 0);
    this.setState({ [name]: value });
  }

  resetEquipmentOverride(name, value) {
    this.setState({ [name]: value });
    console.log("resetEquipmentOverride called: " + value);
    if (value === 0) {
      this.setValue("noOfEBikes", 0);
      this.setValue("noOfBabySeats", 0);
      this.setValue("noOfTrailAlongs", 0);
      this.setValue("noOfKiddieCarriers", 0);
      this.setValue("noOfSmallKidsBikes", 0);
      this.setValue("noOfLargeKidsBikes", 0);
    }
  }

  setValue(name, value) {
    let fieldsToTriggerTheRecalculation = [
      `status`,
      `noOfAdult`,
      `noOfChildren`,
      'noOfBabies',
      `adultPrice`,
      `childPrice`,
      `noOfFamilyGroups`,
      `familyRate`,
      `noOfAdditionals`,
      `additionalRate`,
      `noOfAddChildren`,
      `noOfAddAdult`,
      `family`,
      'noOfEBikes',
      'noOfBabySeats',
      `noOfTrailAlongs`,
      `noOfKiddieCarriers`,
      `noOfLargeKidsBikes`,
      `noOfSmallKidsBikes`,
      `eBikePrice`,
      `babySeatPrice`,
      `trailAlongPrice`,
      `kiddieCarrierPrice`,
      `smallKidsBikePrice`,
      `largeKidsBikePrice`,
    ];

    if (name === `tourDate`) {
      this.setState({
        loading: true,
        tourDate: value,
      });

      getProductTourPricing(
        this.state.customerId,
        this.state.productId,
        moment(value).format(`YYYY-MM-DD`),
      )
        .then((result) => {
          let newState = { loading: false };
          if (result) {
            newState.confirmedByPartner = parseInt(result.confirmedByPartner);
            //newState.adultPrice = (result.adultPrice ? parseFloat(result.adultPrice) : 0);
            newState.childPrice = result.childPrice
              ? parseFloat(result.childPrice)
              : 0;
            newState.familyRate = result.familyRate
              ? parseFloat(result.familyRate)
              : 0;
            newState.additionalRate = result.additionalRate
              ? parseFloat(result.additionalRate)
              : 0;
            newState.priceOrigin = this.generatePriceOriginMessage(result);

            // Equipment Prices Begins
            newState.eBikePrice = result.eBikePrice
              ? parseFloat(result.eBikePrice)
              : 0;
            newState.babySeatPrice = result.babySeatPrice
              ? parseFloat(result.babySeatPrice)
              : 0;
            newState.trailAlongPrice = result.trailAlongPrice
              ? parseFloat(result.trailAlongPrice)
              : 0;
            newState.kiddieCarrierPrice = result.kiddieCarrierPrice
              ? parseFloat(result.kiddieCarrierPrice)
              : 0;
            newState.smallKidsBikePrice = result.smallKidsBikePrice
              ? parseFloat(result.smallKidsBikePrice)
              : 0;
            newState.largeKidsBikePrice = result.largeKidsBikePrice
              ? parseFloat(result.largeKidsBikePrice)
              : 0;

            console.log("Calling setEquip inside getProductTourPricing");
            this.setTotalEquipmentCost();
            // Equipment Prices Ends
          }

          console.log("calling updateEquipmentInventory");
          this.updateEquipmentInventory(moment(value).format(`YYYY-MM-DD`));

          checkIfDateIsBooked(
            this.state.productId,
            moment(value).format(`YYYY-MM-DD`),
          )
            .then((result) => {
              newState.bookedDate = result.isBooked ? true : false;
              this.setState(newState, this.totalRider);
            })
            .catch(() => {
              this.setState({ loading: false });
            });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } else if (name === `customerId`) {
      this.setState({ loading: true });
      let newStateFragment = { customerId: value };
      getCustomerCommission(value)
        .then((result) => {
          if (result) {
            console.log("inside getCustomerCommission");
            let commission = result.commission
              ? (parseFloat(result.commission) * this.state.totalGross) / 100
              : 0;
            let net = this.state.totalGross - commission;
            newStateFragment.commissionLevel = result.commission
              ? parseFloat(result.commission)
              : 0;
            newStateFragment.commission = parseFloat(
              parseFloat(commission).toFixed(2),
            );
            newStateFragment.totalNet = parseFloat(parseFloat(net).toFixed(2));
            newStateFragment.partnerEmail = result.email ? result.email : ``;
            newStateFragment.customerNotes = result.customerNotes
              ? result.customerNotes.trim()
              : ``;

            if (result.bookingRefID && parseInt(result.bookingRefID) === 1) {
              newStateFragment.bookingRefIDIsRequired = true;
            } else {
              newStateFragment.bookingRefIDIsRequired = false;
            }
          }

          let requestedDate = moment().format(`YYYY-MM-DD`);
          if (this.state.tourDate)
            requestedDate = moment(this.state.tourDate).format(`YYYY-MM-DD`);

          console.log("calling getProductTourPricing");
          getProductTourPricing(value, this.state.productId, requestedDate)
            .then((result) => {
              console.log("Inside getProductTourPricing loop");
              if (Number(value) === 211) {
                newStateFragment.bookingSourceIsRequired = true;
              } else {
                newStateFragment.bookingSourceIsRequired = false;
              }

              if (result) {
                newStateFragment.additionalRate = result.additionalRate
                  ? parseFloat(result.additionalRate)
                  : 0;
                //newStateFragment.adultPrice = (result.adultPrice ? parseFloat(result.adultPrice) : 0);
                newStateFragment.childPrice = result.childPrice
                  ? parseFloat(result.childPrice)
                  : 0;
                newStateFragment.familyRate = result.familyRate
                  ? parseFloat(result.familyRate)
                  : 0;
                newStateFragment.priceOrigin =
                  this.generatePriceOriginMessage(result);

                // NOTE: There is no special pricing on equipment for a specific partner, use product pricing
              }

              newStateFragment.loading = false;

              this.setState(newStateFragment, this.totalRider);
            })
            .catch(() => {
              console.log("ERROR : getting getProductTourPricing");
              this.setState({ loading: false });
            });
        })
        .catch(() => {
          console.log("ERROR : getting getCustomerCommission");
          this.setState({ loading: false });
        });
    } else if (fieldsToTriggerTheRecalculation.indexOf(name) > -1) {
      this.setState({ [name]: value }, this.totalRider);
    } else {
      this.setState({ [name]: value });
    }
    if (name === "voucherValue") {
      this.setState((state) => {
        return {
          ...state,
          voucherValue: Math.abs(value),
        };
      });
    }
    if (name === "bookingSource") {
      this.setState((state) => {
        return {
          ...state,
          bookingSourceIsRequired: false,
        };
      });
    }
    if (name === "voucherCode") {
      this.setState({ voucher: 1 });
    }
  }
  recalculateTotal = (e) => {};

  calculateDiscount(totalGross) {
    return new Promise((resolve, reject) => {
      console.log("Inside calculateDiscount: " + totalGross);

      getDiscounts({ discountCode: this.state.voucherCode })
        .then((discount) => {
          if (discount.length < 1) {
            reject("Please enter a valid discount code.");
          }

          const expireDate = moment(discount[0]["expireDate"]);
          const today = new Date();
          if (!discount[0].active || expireDate.isBefore(moment(today))) {
            reject("Discount has either expired or it has been used");
          }

          const discountAmount = (
            discount[0].discountType == "ABSOLUTE"
              ? discount[0].discountAmount
              : (discount[0].discountAmount / 100) * totalGross
          ).toFixed(2);

          console.log("DISCOUNT AMOUNT: " + discountAmount);

          resolve(discountAmount);
        })
        .catch((err) => {
          reject("Discount has either expired or it has been used");
        });
    });
  }
  
  updateEquipmentInventory(date) {
    // Get Inventory Consumption
    // moment(value).format(`YYYY-MM-DD`)
    console.log("Inside updateEquipmentInventory");
    getEquipmentInventory(date).then((availableInventory) => {
      this.setValue('totalInventory', availableInventory);

      console.log("totalInventory['largeKidsBikeInventory'].totalBooked: " + this.state.totalInventory['largeKidsBikeInventory'].totalBooked);
      console.log("totalInventory['largeKidsBikeInventory'].totalInventory: " + this.state.totalInventory['largeKidsBikeInventory'].totalInventory);

      // All data fetched from backend. Show the UI
      this.setState({ bookingIDExists: true });
    }).catch((err) => {
        console.log(id);
        this.setState({
            loading: false,
            validationErrors: [
              `Unable to get equipment inventory`,
            ],
            bookingIDExists: false,
        });                
    });
  }

  applyDiscount = () => {
    // console.log("applyDiscount::APPLY DISCOUNT CLICKED (voucherCode): " + this.state.voucherCode);
    // console.log("applyDiscount::APPLY DISCOUNT CLICKED (discounted): " + this.state.discounted);
    // console.log("applyDiscount::APPLY DISCOUNT CLICKED (disallowDiscountEdit): " + this.state.disallowDiscountEdit);

    if (this.state.disallowDiscountEdit) {
      return;
    }

    let newState = this.state;

    if (!this.state.voucherCode) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: ["Please enter a valid discount code."],
        };
      });
      return;
    }

    // console.log("applyDiscount::calculateDiscount CALLING calculateDiscount  : " + newState.totalGross);
    this.calculateDiscount(newState.totalGross + newState.totalEquipmentCost).then((discountAmount) => {
        // console.log("applyDiscount::calculateDiscount returned : " + discountAmount);
        // console.log("applyDiscount::his.state.discountedAmount : " + this.state.discountedAmount);

        newState = this.updateAmounts(newState, discountAmount);
        // console.log("AFTER updateAmounts : " + discountAmount);

        newState.discountedAmount = discountAmount;
        newState.discounted = true;
        newState.disableTotalGross = true;

        this.setState(newState);
        // console.log("applyDiscount::disallowDiscountEdit : " + this.state.disallowDiscountEdit);
        // console.log("applyDiscount::DISCOUNTED : " + this.state.discounted);
      })
      .catch((err) => {
        console.log(err);
        this.setState((state) => {
          return {
            ...state,
            voucherCode: "",
            validationErrors: [`${err}`],
          };
        });
      });
  }; // End of Apply Discount Function

  clearDiscount = () => {
    let newState = this.state;
    console.log("INSIDE clear discount ");

    newState = this.updateAmounts(newState, 0);

    newState.discountedAmount = 0;
    newState.discounted = false;
    newState.disableTotalGross = false;

    // clear the enter discount code field and remove voucher code from the payment panel
    newState.voucherValue = 0;
    newState.voucherCode = "";

    this.setState(newState);
  }; //end of clear discount function

  resetForm() {
    let stateCopy = initialState;
    (stateCopy.userId = this.props.user.userId), this.setState(stateCopy);
  }

  render() {
    let overlay = false;

    if (this.state.loading) {
      let overlayContent = (
        <div
          style={{
            top: `50%`,
            position: `absolute`,
            left: `50%`,
          }}
        >
          <CircularProgress />
        </div>
      );

      if (this.state.purchaseWasCreated || this.state.purchaseWasUpdated) {
        let text = (
          <p>
            Tour purchase was created (Bonza booking ID: {this.state.purchaseId}
            )
          </p>
        );
        let link = (
          <div>
            <div>
              <Link
                to={`/purchases/edit-tour/${this.state.purchaseId}`}
                className="no-underline"
              >
                <Button variant="contained">Edit purchase</Button>
              </Link>
            </div>
            <div style={{ paddingTop: `10px` }}>
              <Link
                to={`/purchases/${this.state.purchaseId}/payment`}
                className="no-underline"
              >
                <Button variant="contained" className="button-green">
                  Take payment
                </Button>
              </Link>
            </div>
            <div style={{ paddingTop: `10px` }}>
              <Button
                variant="contained"
                className="button-orange"
                onClick={this.resetForm.bind(this)}
              >
                Add another purchase
              </Button>
            </div>
            <div style={{ paddingTop: `10px` }}>
              <Link to="/" className="no-underline">
                <Button variant="contained" color="primary">
                  Back to home
                </Button>
              </Link>
            </div>
          </div>
        );

        if (this.state.purchaseWasUpdated) {
          text = <p>Tour purchase was updated</p>;
          link = (
            <div>
              <div>
                <Button
                  variant="contained"
                  onClick={() => {
                    this.setState({
                      loading: false,
                      purchaseWasUpdated: false,
                    });
                  }}
                >
                  Edit purchase
                </Button>
              </div>
              <div style={{ paddingTop: `10px` }}>
                <Link
                  to={`/purchases/${this.state.purchaseId}/payment`}
                  className="no-underline"
                >
                  <Button variant="contained" className="button-green">
                    Take payment
                  </Button>
                </Link>
              </div>
              <div style={{ paddingTop: `10px` }}>
                <Link to="/" className="no-underline">
                  <Button variant="contained" color="primary">
                    Back to home
                  </Button>
                </Link>
              </div>
            </div>
          );
        }

        overlayContent = (
          <div
            style={{
              top: `calc(40% - 80px)`,
              left: `calc(50% - 80px)`,
              position: `fixed`,
              textAlign: `center`,
            }}
          >
            <CheckIcon color="primary" style={{ fontSize: 80 }} />
            <br />
            {text}
            {link}
          </div>
        );
      }

      overlay = (
        <div
          style={{
            position: `fixed`,
            width: `100%`,
            height: `100%`,
            backgroundColor: `rgba(255,255,255,0.6)`,
            zIndex: `100`,
            top: `0px`,
            left: `0px`,
          }}
        >
          {overlayContent}
        </div>
      );
    }

    let uniqueBookingReferenceIdNotification = false;
    if (this.state.bookingRefID) {
      if (!this.state.bookingRefIDIsUnique) {
        if (
          !this.state.bookingRefIDInitial ||
          (this.state.bookingRefIDInitial &&
            this.state.bookingRefID !== this.state.bookingRefIDInitial)
        ) {
          uniqueBookingReferenceIdNotification = (
            <Tooltip
              title="Such identifier already exists"
              placement="top"
              enterDelay={300}
            >
              <Typography variant="subtitle2" style={{ color: `red` }}>
                This booking ID already exists
              </Typography>
            </Tooltip>
          );
        }
      }
    }

    let panelHeaderStyle = {
      backgroundColor: `rgb(30, 136, 229)`,
      color: `white`,
    };

    let enteredByInfo = false;
    this.props.users.map((item) => {
      let userId = this.state.userId;
      if (this.state.purchaseId > 0) userId = this.state.enteredBy;

      if (item.userId === userId) {
        if (this.state.enteredAt) {
          enteredByInfo = (
            <div>
              <p>
                Entered by: {item.firstname} {item.lastname}
              </p>
              <p>
                Entered on:{" "}
                {moment(this.state.enteredAt).format(
                  config.momentDateTimeFormat,
                )}
              </p>
            </div>
          );
        } else {
          enteredByInfo = (
            <div>
              <p>
                Entered by: {item.firstname} {item.lastname}
              </p>
            </div>
          );
        }
      }
    });

    let updatedByInfo = false;
    if (this.state.purchaseId > 0) {
      this.props.users.map((item) => {
        if (item.userId === this.state.updatedBy) {
          if (this.state.updatedAt) {
            updatedByInfo = (
              <div>
                <p>
                  Last updated by: {item.firstname} {item.lastname}
                </p>
                <p>
                  Last updated on:{" "}
                  {moment(this.state.updatedAt).format(
                    config.momentDateTimeFormat,
                  )}
                </p>
              </div>
            );
          } else {
            updatedByInfo = (
              <div>
                <p>
                  Last updated by: {item.firstname} {item.lastname}
                </p>
              </div>
            );
          }
        }
      });
    }

    // let additionaMiscPurchasesText = ``;
    // if (
    //   this.state.miscPurchases &&
    //   this.state.miscPurchases.items &&
    //   Array.isArray(this.state.miscPurchases.items)
    // ) {
    //   let texts = [];
    //   this.state.miscPurchases.items.map((miscPurchase) => {
    //     let productId = parseInt(miscPurchase.productID);
    //     let quantity = parseInt(miscPurchase.qty);

    //     if (productId > 0 && quantity > 0 && this.props.products) {
    //       this.props.products.map((product) => {
    //         if (product.productID === productId) {
    //           texts.push(
    //             `${product.name} (${quantity} * ${"$" + miscPurchase.price})`,
    //           );
    //         }
    //       });
    //     }
    //   });

    //   if (texts.length > 0) {
    //     additionaMiscPurchasesText = `(` + texts.join(`, `) + `)`;
    //   }
    // }

    const isPurchasedProductVoucher =
      !!this.state.product && this.state.product.typeCode === "VOUCHERS";
    // const miscPurchasesTotal =
    //   !!this.state.miscPurchases && this.state.miscPurchases.total
    //     ? this.state.miscPurchases.total
    //     : 0;
    return (
      <div style={{ position: `relative` }}>
        {overlay}
        <div style={{ paddingBottom: `10px` }}>
          {this.state.locked}
          {this.state.locked ? (
            <div>
              <LockedPurchaseNotification />
            </div>
          ) : (
            false
          )}

          <ExpansionPanel
            expanded={!this.state.travelerSectionCollapsed}
            onChange={() => {
              this.togglePanel(`travelerSectionCollapsed`);
            }}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
              style={panelHeaderStyle}
            >
              <div>
                <div style={{ float: `left`, paddingRight: `10px` }}>
                  <PersonIcon />
                </div>{" "}
                Traveller details
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: `100%` }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Lead traveller last name"
                      value={this.state.travelerLastname}
                      fullWidth={true}
                      required={true}
                      name="travelerLastname"
                      onChange={this.setValue}
                      // disabled={this.state.locked ? true : false}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Lead traveller first name"
                      value={this.state.travelerFirstname}
                      name="travelerFirstname"
                      onChange={this.setValue}
                      // disabled={this.state.locked ? true : false}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaSelectField
                      title="Origin country"
                      value={this.state.originCountry}
                      options={config.countries}
                      name="originCountry"
                      onChange={this.setValue}
                    />
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Additional traveller names"
                      fullWidth={true}
                      multiline={true}
                      rows={2}
                      value={this.state.additionalNames}
                      name="additionalNames"
                      onChange={this.setValue}
                    />
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Phone number"
                      value={this.state.phone}
                      fullWidth={true}
                      name="phone"
                      onChange={this.setValue}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Hotel"
                      value={this.state.hotel}
                      fullWidth={true}
                      name="hotel"
                      onChange={this.setValue}
                    />
                  </div>
                </div>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            expanded={!this.state.saleSectionCollapsed}
            onChange={() => {
              this.togglePanel(`saleSectionCollapsed`);
            }}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
              style={panelHeaderStyle}
            >
              <div>
                <div style={{ float: `left`, paddingRight: `10px` }}>
                  <InfoIcon />
                </div>{" "}
                Sale details
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: `100%` }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                    style={noMargin}
                  >
                    <BonzaSelectField
                      title="Status"
                      value={this.state.status}
                      options={config.statuses}
                      name="status"
                      capitalize={true}
                      // disabled={this.state.locked ? true : false}
                      onChange={this.setValue}
                    />
                  </div>
                  {this.state.purchaseId > 0 ? (
                    <div
                      className="col-xs-12 col-sm-6 col-md-8 col-lg-9 m-b-15"
                      style={{ textAlign: `right` }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Bonza booking ID:{" "}
                        <strong>{this.state.purchaseId}</strong>
                      </Typography>
                    </div>
                  ) : (
                    false
                  )}
                </div>

                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                    style={noMargin}
                  >
                    <BonzaBooleanField
                      title="Gift Certificate/Voucher Booking"
                      value={this.state.voucher}
                      name="voucher"
                      onChange={this.setValueVoucher}
                    />
                  </div>
                </div>

                {this.state.voucher === 1 ? (
                  <div className="row">
                    <div
                      className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                      style={noMargin}
                    >
                      <BonzaTextField
                        title="Voucher Purchaser Last Name/Company Name"
                        value={this.state.voucherLastname}
                        name="voucherLastname"
                        onChange={this.setValue}
                      />
                    </div>
                    <div
                      className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                      style={noMargin}
                    >
                      <BonzaTextField
                        title="Voucher Purchaser First Name"
                        value={this.state.voucherFirstname}
                        name="voucherFirstname"
                        onChange={this.setValue}
                      />
                    </div>
                  </div>
                ) : (
                  false
                )}

                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                    style={noMargin}
                  >
                    <BonzaSelectField
                      title="Booking partner"
                      options={this.props.customers}
                      optionsIdField="customerID"
                      optionsTitleField="name"
                      required={true}
                      value={this.state.customerId}
                      // disabled={this.state.locked ? true : false}
                      name="customerId"
                      onChange={this.setValue}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Booking partner notes"
                      value={this.state.customerNotes}
                      multiline={true}
                      disabled={true}
                      rows={this.state.customerNotes ? 8 : 2}
                      fullWidth={true}
                      name="customerNotes"
                      onChange={this.setValue}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15">
                    <div style={{ display: `flex` }}>
                      <div style={{ paddingRight: `10px`, paddingTop: `4px` }}>
                        <FormLabel style={{ whiteSpace: `nowrap` }}>
                          Booking partner reference
                        </FormLabel>
                      </div>
                      <div style={{ paddingRight: `10px` }}>
                        <TextField
                          type="text"
                          required={this.state.bookingRefIDIsRequired}
                          value={this.state.bookingRefID}
                          onBlur={(event) => {
                            this.checkReferenceIdUniqueness(event.target.value);
                          }}
                          onChange={(event) => {
                            this.setValue(`bookingRefID`, event.target.value);
                          }}
                        />
                        {uniqueBookingReferenceIdNotification}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15">
                    <BonzaSelectField
                      title="Booking source"
                      required={this.state.bookingSourceIsRequired}
                      value={this.state.bookingSource}
                      options={config.bookingSources}
                      name="bookingSource"
                      onChange={this.setValue}
                    />
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTextField
                      title="Travel agency"
                      value={this.state.travelAgency}
                      name="travelAgency"
                      onChange={this.setValue}
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                    style={noMargin}
                  >
                    <BonzaBooleanField
                      title="Famil"
                      value={this.state.famils}
                      name="famils"
                      onChange={this.setValue}
                    />
                  </div>
                </div>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            expanded={!this.state.tourSectionCollapsed}
            onChange={() => {
              this.togglePanel(`tourSectionCollapsed`);
            }}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
              style={panelHeaderStyle}
            >
              <div>
                <div style={{ float: `left`, paddingRight: `10px` }}>
                  <DirectionsBikeIcon />
                </div>{" "}
                Tour details
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: `100%` }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                    style={noMargin}
                  >
                    <BonzaTourTypeSelect
                      title="Tour type"
                      value={this.state.productId}
                      name="productId"
                      required={true}
                      // disabled={this.state.locked ? true : false}
                      onChange={this.setValueTourType}
                    />
                  </div>
                </div>

                {this.state.productId > 0 ? (
                  <div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Override allotment"
                          value={this.state.twoDayRule}
                          name="twoDayRule"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                    </div>

                    <div className="row tour-purchase-page_date-picker-container">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaDatePickerField
                          title="Tour date"
                          value={this.state.tourDate}
                          name="tourDate"
                          required={!this.state.purchaseIsVoucher}
                          // disabled={this.state.locked ? true : false}
                          allotments={
                            this.state.twoDayRule
                              ? false
                              : this.state.allotmentsData
                          }
                          onChange={this.setValue}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Override departure time"
                          value={this.state.optionTourTime}
                          name="optionTourTime"
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        {this.state.optionTourTime === 1 ? (
                          <BonzaTextField
                            title="Departure time"
                            value={this.state.overrideTourTime}
                            name="overrideTourTime"
                            onChange={this.setValue}
                          />
                        ) : (
                          false
                        )}
                      </div>
                    </div>

                    <Divider />

                    {this.state.priceOrigin ? (
                      <div className="row">
                        <div
                          className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                          style={{ paddingTop: `10px` }}
                        >
                          <Paper elevation={1} style={{ padding: `14px` }}>
                            <Typography component="p">
                              {this.state.priceOrigin}
                            </Typography>
                          </Paper>
                        </div>
                      </div>
                    ) : (
                      false
                    )}

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Family booking"
                          // disabled={this.state.locked ? true : false}
                          value={this.state.family}
                          name="family"
                          onChange={this.resetPaxSelection}
                        />
                      </div>
                    </div>

                    {this.state.family === 1 ? (
                      <div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Family groups"
                              type="number"
                              value={this.state.noOfFamilyGroups}
                              name="noOfFamilyGroups"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValueOfAdultEquipments}
                            />
                          </div>
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Family rate ($)"
                              type="number"
                              value={this.state.familyRate}
                              name="familyRate"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValue}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Additional family riders (adults)"
                              type="number"
                              value={this.state.noOfAddAdult}
                              name="noOfAddAdult"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValueOfAdultEquipments}
                            />
                          </div>
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Additional rider rate ($)"
                              type="number"
                              value={this.state.additionalRate}
                              name="additionalRate"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValue}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Additional family riders (children)"
                              type="number"
                              value={this.state.noOfAddChildren}
                              name="noOfAddChildren"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValueOfKidEquipments}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Number of adults"
                              type="number"
                              value={this.state.noOfAdult}
                              name="noOfAdult"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValueOfAdultEquipments}
                            />
                          </div>
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Adult price ($)"
                              type="number"
                              value={this.state.adultPrice}
                              name="adultPrice"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValue}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Number of children"
                              type="number"
                              value={this.state.noOfChildren}
                              name="noOfChildren"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValueOfKidEquipments}
                            />
                          </div>
                          <div
                            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                            style={noMargin}
                          >
                            <BonzaTextField
                              title="Child price ($)"
                              type="number"
                              value={this.state.childPrice}
                              name="childPrice"
                              // disabled={this.state.locked ? true : false}
                              onChange={this.setValue}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Babies under 2"
                          type="number"
                          value={this.state.noOfBabies}
                          name="noOfBabies"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfInfantEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Total riders"
                          type="number"
                          value={this.state.totalRiders}
                          disabled={
                            this.state.totalRidersDisabled ? true : false
                          }
                          name="totalRiders"
                          // // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        paddingTop: `10px`,
                        paddingBottom: `10px`,
                      }}
                    >
                      <Divider />
                    </div>

                    {/* Equipment Section Starts Here */}
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Override Equipment Inventory"
                          value={this.state.overrideEquipmentCount}
                          name="overrideEquipmentCount"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.resetEquipmentOverride}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of e-Bikes Required"
                          type="number"
                          value={this.state.noOfEBikes}
                          name="noOfEBikes"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfAdultEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="e-Bike Price ($)"
                          type="number"
                          value={this.state.eBikePrice}
                          name="eBikePrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                            {this.state.totalInventory['eBikeInventory'] == null ? 0/0 :
                              this.state.totalInventory['eBikeInventory'].totalBooked + `/` + 
                                        this.state.totalInventory['eBikeInventory'].totalInventory}
                            disabled= 'true'
                            name="eBikeInventory"
                          />
                        </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of Baby Seats Required"
                          type="number"
                          value={this.state.noOfBabySeats}
                          name="noOfBabySeats"
                          // disabled={true}
                          onChange={this.setValueOfInfantEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Baby Seat Price ($)"
                          type="number"
                          value={this.state.babySeatPrice}
                          name="babySeatPrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                            {this.state.totalInventory['babySeatInventory'] == null ? 0/0 :
                              this.state.totalInventory['babySeatInventory'].totalBooked + `/` + 
                                        this.state.totalInventory['babySeatInventory'].totalInventory}
                            disabled= 'true'
                            name="babySeatInventory"
                          />
                        </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of Trail Alongs Required"
                          type="number"
                          value={this.state.noOfTrailAlongs}
                          name="noOfTrailAlongs"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfKidEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Trail Along Price ($)"
                          type="number"
                          value={this.state.trailAlongPrice}
                          name="trailAlongPrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                            {this.state.totalInventory['trailAlongInventory'] == null ? 0/0 :
                              this.state.totalInventory['trailAlongInventory'].totalBooked + `/` + 
                                        this.state.totalInventory['trailAlongInventory'].totalInventory}
                            disabled= 'true'
                            name="traiAlongInventory"
                          />
                        </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of Kiddie Carriers Required"
                          type="number"
                          value={this.state.noOfKiddieCarriers}
                          name="noOfKiddieCarriers"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfKidEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Kiddie Carrier Price ($)"
                          type="number"
                          value={this.state.kiddieCarrierPrice}
                          name="kiddieCarrierPrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                              {this.state.totalInventory['kiddieCarrierInventory'] == null ? 0/0 :
                                this.state.totalInventory['kiddieCarrierInventory'].totalBooked + `/` + 
                                        this.state.totalInventory['kiddieCarrierInventory'].totalInventory}
                            disabled= 'true'
                            name="kiddieCarrierInventory"
                          />
                        </div>

                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of Small Kids Bikes Required"
                          type="number"
                          value={this.state.noOfSmallKidsBikes}
                          name="noOfSmallKidsBikes"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfKidEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Small Kids Bike Price ($)"
                          type="number"
                          value={this.state.smallKidsBikePrice}
                          name="smallKidsBikePrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                              {this.state.totalInventory['smallKidsBikeInventory'] == null ? 0/0 :
                              this.state.totalInventory['smallKidsBikeInventory'].totalBooked + `/` + 
                                    this.state.totalInventory['smallKidsBikeInventory'].totalInventory}
                            name="smallKidsBikeInventory"
                            disabled= 'true'
                          />
                        </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Number of Large Kids Bikes Required"
                          type="number"
                          value={this.state.noOfLargeKidsBikes}
                          name="noOfLargeKidsBikes"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValueOfKidEquipments}
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Large Kids Bike Price ($)"
                          type="number"
                          value={this.state.largeKidsBikePrice}
                          name="largeKidsBikePrice"
                          // disabled={this.state.locked ? true : false}
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Inventory Sold/Total Inventory"
                            type="string"
                            value=
                            {this.state.totalInventory['largeKidsBikeInventory'] == null ? 0/0 :
                            this.state.totalInventory['largeKidsBikeInventory'].totalBooked + `/` + 
                                          this.state.totalInventory['largeKidsBikeInventory'].totalInventory}
                            disabled= 'true'
                            name="largeKidsBikeInventory"
                          />
                        </div>
                    </div>

                    {/* Equipment Section Ends Here */}
                  </div>
                ) : (
                  false
                )}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {this.state.productId > 0 ? (
            <div>
              <ExpansionPanel
                expanded={!this.state.emailConfirmationSectionCollapsed}
                onChange={() => {
                  this.togglePanel(`emailConfirmationSectionCollapsed`);
                }}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
                  style={panelHeaderStyle}
                >
                  <div>
                    <div style={{ float: `left`, paddingRight: `10px` }}>
                      <EmailIcon />
                    </div>{" "}
                    Email confirmation details
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{ width: `100%` }}>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Send confirmation email to booking partner reservations staff"
                          value={this.state.sendToPartner}
                          name="sendToPartner"
                          onChange={this.setValue}
                        />
                      </div>

                      {this.state.sendToPartner === 1 ? (
                        <div
                          className="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Booking partner email address"
                            type="email"
                            fullWidth={true}
                            value={this.state.partnerEmail}
                            name="partnerEmail"
                            onChange={this.setValue}
                          />
                        </div>
                      ) : (
                        false
                      )}
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Send confirmation email to traveller"
                          value={this.state.sendToGuest}
                          name="sendToGuest"
                          onChange={this.setValue}
                        />
                      </div>

                      {this.state.sendToGuest === 1 ? (
                        <div
                          className="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Traveller email address"
                            type="email"
                            fullWidth={true}
                            value={this.state.email}
                            name="email"
                            onChange={this.setValue}
                          />
                        </div>
                      ) : (
                        false
                      )}
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Traveller notes (to be included in confirmation email)"
                          multiline={true}
                          fullWidth={true}
                          value={this.state.guestNote}
                          name="guestNote"
                          onChange={this.setValue}
                        />
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={!this.state.bookingStatusSectionCollapsed}
                onChange={() => {
                  this.togglePanel(`bookingStatusSectionCollapsed`);
                }}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
                  style={panelHeaderStyle}
                >
                  <div>
                    <div style={{ float: `left`, paddingRight: `10px` }}>
                      <CheckIcon />
                    </div>{" "}
                    Booking status
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{ width: `100%` }}>
                    <div className="row">
                      <div
                        className="col-xs-4 col-sm-4 col-md-4 col-lg-4"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Checked in"
                          value={this.state.checkIn}
                          name="checkIn"
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                        className="col-xs-4 col-sm-4 col-md-4 col-lg-4"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="No show"
                          value={this.state.noShow}
                          name="noShow"
                          onChange={this.setValue}
                        />
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
                // Add Waiver Form Related Information
                <ExpansionPanelDetails>
                  <div style={{ width: `100%` }}>
                    <div className="row">
                      <div
                        className="col-xs-4 col-sm-4 col-md-4 col-lg-4"
                        style={noMargin}
                      >
                        <BonzaBooleanField
                          title="Waiver"
                          value={this.state.waiverFormSubmitted}
                          name="waiverFormSubmitted"
                          onChange={this.setValue}
                        />
                      </div>
                      <div
                        className="col-xs-8 col-sm-8 col-md-8 col-lg-8"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Waiver Form URL"
                          type="text"
                          fullWidth={true}
                          value={this.state.waiverFormURL}
                          name="waiverFormURL"
                          onChange={this.setValue}
                        />
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={!this.state.bookingVoucherSectionCollapsed}
                onChange={() => {
                  this.togglePanel(`bookingVoucherSectionCollapsed`);
                }}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
                  style={panelHeaderStyle}
                >
                  <div>
                    <div style={{ float: `left`, paddingRight: `10px` }}>
                      <CheckIcon />
                    </div>{" "}
                    Vouchers
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{ width: `100%` }}>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        {
                          // NOTE: The same page is used to buy Gift Vouchers, aka Vouchers
                          // In that case "Voucher IDs" is shown as the label
                          <BonzaTextField
                            title={
                              isPurchasedProductVoucher
                                ? "Voucher IDs"
                                : "Enter discount code"
                            }
                            value={this.state ? this.state.voucherCode : ""}
                            name="voucherCode"
                            disabled={this.state.disallowDiscountEdit ? true : false}
                            //disabled={!this.state.purchaseIsVoucher}
                            //disabled={isPurchasedProductVoucher}

                            onChange={this.setValue}
                          />
                        }
                      </div>

                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        {isPurchasedProductVoucher && (
                          <BonzaTextField
                            title="Voucher Value"
                            type="number"
                            value={this.state.voucherValue}
                            min={1}
                            name="voucherValue"
                            onChange={this.setValue}
                            disabled={true}
                            onBlur={this.recalculateTotal}
                          />
                        )}
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        {(this.state.voucherExpireDate ||
                          !this.state.purchaseId) &&
                          isPurchasedProductVoucher && (
                            <BonzaDatePickerField
                              title="Voucher Expire Date"
                              value={this.state.voucherExpireDate}
                              name="voucherExpireDate"
                              onChange={this.setValue}
                            />
                          )}
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15"
                        style={noMargin}
                      >
                        {/* {this.state.voucherIsUsed > 0 && <p> Voucher has being used </p>  } */}
                      </div>
                    </div>
                    {!this.state.purchaseIsVoucher && (
                      <div>
                        <div
                          style={{ margin: "1rem", display: "inline-block" }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.applyDiscount}
                            disabled={
                              this.state.disallowDiscountEdit ? true : false
                            }
                          >
                            Apply
                          </Button>
                        </div>
                        {!this.state.disallowDiscountEdit && (
                          <div
                            style={{ margin: "1rem", display: "inline-block" }}
                          >
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={this.clearDiscount}
                              disabled={
                                !this.state.disableTotalGross &&
                                !this.state.disallowDiscountEdit
                              }
                            >
                              Clear Discount
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={!this.state.paymentSectionCollapsed}
                onChange={() => {
                  this.togglePanel(`paymentSectionCollapsed`);
                }}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
                  style={panelHeaderStyle}
                >
                  <div>
                    <div style={{ float: `left`, paddingRight: `10px` }}>
                      <PaymentIcon />
                    </div>{" "}
                    Payment
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{ width: `100%` }}>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Total gross sale"
                          type="number"
                          // value={this.state.totalGross + miscPurchasesTotal + this.state.totalEquipmentCost}
                          value={this.state.totalGross + this.state.totalEquipmentCost}
                          name="totalGross"
                          //disabled={this.state.locked || this.state.disableTotalGross ? true : false}
                          // disabled={this.state.disableTotalGross ? true : false}
                          onChange={this.setValueTotalGross}
                          
                        />
                      </div>

                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Commission"
                          type="number"
                          value={this.state.commission}
                          name="commission"
                          disabled={true}
                          onChange={this.setValue}
                        />
                      </div>

                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                        style={noMargin}
                      >
                        {this.state.voucherCode &&
                          !isPurchasedProductVoucher && (
                            <span className="MuiFormLabel-root-97">
                              {" "}
                              {this.state.voucherCode}{" "}
                            </span>
                          )}

                        {this.state.voucherValue > 0 && (
                          <BonzaTextField
                            title={
                              isPurchasedProductVoucher
                                ? "Voucher Value"
                                : "Discount Amount"
                            }
                            type="number"
                            value={this.state.voucherValue}
                            min={1}
                            name="voucherValue"
                            onChange={this.setValue}
                            disabled={true}
                          />
                        )}
                      </div>

                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Total net sale"
                          type="number"
                          value={this.state.totalNet}
                          name="totalNet"
                          disabled={true}
                          onChange={this.setValue}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-4 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <div>{enteredByInfo}</div>
                        <div>{updatedByInfo}</div>
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-8 col-lg-8 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Internal notes"
                          fullWidth={true}
                          multiline={true}
                          rows={6}
                          value={this.state.internalNotes}
                          name="internalNotes"
                          onChange={this.setValue}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                        style={noMargin}
                      >
                        {isPurchasedProductVoucher && (
                          <p>
                            Total purchase: ${this.state.totalGross} (Tour) - 
                            ${this.state.voucherValue} (Voucher) - 
                            ${this.state.commission} (Commission) ={" "}
                            <strong>${this.state.totalNet} total</strong>
                          </p>
                        )}
                        {!isPurchasedProductVoucher && (
                          <p>
                            Total purchase: ${this.state.totalGross} (Tour) +
                            ${this.state.totalEquipmentCost} (Equipment) -
                            ${this.state.voucherValue} (Discount) -
                            ${this.state.commission} (Commission) ={" "}
                            <strong>${this.state.totalNet} total</strong>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {this.state.locked ? (
                <div style={{ paddingBottom: `10px` }}>
                  <LockedPurchaseNotification />
                </div>
              ) : (
                false
              )}

              {this.state.purchaseId > 0 ? (
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onFormSubmit}
                  >
                    Update purchase
                  </Button>
                  <Link
                    to={`/purchases/${this.state.purchaseId}/payment`}
                    className="no-underline"
                    style={{ paddingLeft: `10px` }}
                  >
                    <Button variant="contained">Add payment</Button>
                  </Link>
                  <Link
                    to={`/purchases/${this.state.purchaseId}/refund`}
                    className="no-underline"
                    style={{ paddingLeft: `10px` }}
                  >
                    <Button variant="contained">Add refund</Button>
                  </Link>
                  <Link
                    to={`/purchases/${this.state.purchaseId}/history`}
                    className="no-underline"
                    style={{ paddingLeft: `10px` }}
                  >
                    <Button variant="contained">Payment history</Button>
                  </Link>
                  {/* <Link
                    to={`/purchases/edit-misc/${this.state.purchaseId}`}
                    className="no-underline"
                    style={{ paddingLeft: `10px` }}
                  >
                    <Button variant="contained">
                      Edit miscellaneous purchase
                    </Button>
                  </Link> */}
                  {/* <Link
                    to={`/purchases/edit-equipmpent/${this.state.purchaseId}`}
                    className="no-underline"
                    style={{ paddingLeft: `10px` }}
                  >
                    <Button variant="contained">
                      Edit equipment purchase
                    </Button>
                  </Link> */}
                </div>
              ) : (
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onFormSubmit}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onFormSubmitAndTakePayment}
                    style={{ paddingLeft: `10px`, marginLeft: `10px` }}
                  >
                    Save and take payment
                  </Button>
                </div>
              )}
            </div>
          ) : (
            false
          )}
        </div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={this.state.validationErrors.length > 0}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={
            <div>
              {this.state.validationErrors.map((item, index) => (
                <p key={`error_message_${index}`}>{item}</p>
              ))}
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

TourPurchasePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.any.isRequired,
  purchase: PropTypes.any.isRequired,
  customers: PropTypes.array.isRequired,
  customerComission: PropTypes.any.isRequired,
  tourPricing: PropTypes.any.isRequired,
  onTourPriceChange: PropTypes.func.isRequired,
};

/* eslint-disable */
function mapStateToProps(state) {
  const {
    addPurchaseReducer,
    customerReducer,
    userReducer,
    productReducer,
    auth,
  } = state;
  const { loading, error, purchase } = addPurchaseReducer;
  const { customers, customerComission } = customerReducer;
  const { tourPricing, products, purchasePriceUpdating, purchasePriceUpdated } =
    productReducer;
  const { users } = userReducer;
  const { user } = auth;
  return {
    loading,
    error,
    purchase,
    products,
    customers,
    customerComission,
    tourPricing,
    users,
    user,
    purchasePriceUpdating,
    purchasePriceUpdated,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    onTourPriceChange: (data) => dispatch(requestProductPriceUpdate(data)),
  };
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(TourPurchasePage),
);



/** WEBPACK FOOTER **
 ** ./src/containers/TourPurchasePage.js
 **/